import { Link } from "react-router-dom";

export default function RegularBtn({
  to,
  children,
  className = '',
  style=''
}) {
  return (
    <Link to={to} className={`inline-flex items-center justify-center rounded-[10px] px-3.5 py-3 text-[12.2px] font-medium text-black transition-all duration-300 cursor-pointer ${className}`}>
      {children}
    </Link>
  );
}